
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45980","data-name":"Group 45980","transform":"translate(-1179 -715.066)"}},[_c('path',{attrs:{"id":"Path_33772","data-name":"Path 33772","d":"M0 0h30v30H0z","transform":"translate(1179 715.066)","fill":"none"}}),_c('path',{attrs:{"id":"Path_33770","data-name":"Path 33770","d":"M61.408 15.651V10.5a3 3 0 00-3-3h-.75V6a.75.75 0 00-1.5 0v1.5h-9V6a.75.75 0 00-1.5 0v1.5h-.75a3 3 0 00-3 3v11.25a3 3 0 003 3h7.72a6.326 6.326 0 108.78-9.1m-16.5 7.6a1.5 1.5 0 01-1.5-1.5v-7.5a1.5 1.5 0 011.5-1.5h13.5a1.5 1.5 0 011.5 1.5v.387a6.322 6.322 0 00-8.365 8.613zm12.25 1.916a4.833 4.833 0 114.833-4.833 4.838 4.838 0 01-4.833 4.833","transform":"translate(1142.342 715.066)","fill":"#5555f2"}}),_c('path',{attrs:{"id":"Path_33771","data-name":"Path 33771","d":"M59.628 21.01l-1.721-1.09v-2.8a.75.75 0 00-1.5 0v3.208a.752.752 0 00.349.634l2.069 1.311a.75.75 0 00.8-1.268","transform":"translate(1142.342 715.066)","fill":"#5555f2"}})])])
          )
        }
      }
    